import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from 'app/common/avatar';

import { ThemeService } from '@iw/core/services';

import { AccountWithAmountItem } from '../..';

@Component({
  selector: 'iw-user-item',
  standalone: true,
  imports: [TranslateModule, IconModule, AvatarComponent],
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.selected]': 'selected()',
  },
})
export class UserItemComponent {
  readonly themeService = inject(ThemeService);
  user = input.required<AccountWithAmountItem>();
  selected = input(false, { transform: booleanAttribute });
  useThemeImage = input(false, { transform: booleanAttribute });

  walletImgSrc = computed(() => {
    const isDark = this.themeService.isDarkTheme();
    const theme =
      (this.selected() || this.useThemeImage()) && !isDark ? 'light' : 'dark';
    return `/assets/images/wallet-${theme}.png`;
  });
}
